const { isMoment } = require("moment");

angular.module('dentalLinksDirectives')
    // Angular File Upload module does not include this directive
    // Only for example
    .directive('access', ['Auth', 'USER_ROLES', '$rootScope', function (Auth, USER_ROLES, $rootScope) {
        return {
            restrict: 'A',
            link: function (scope, $element, attrs) {
                var prevDisp = $element.css('display') || '';
                var requiredRoles = attrs.access.split(/[,\s]+/);
                
                function updateVisibility() {
                    if (!Auth.authorize(requiredRoles)) {
                        $element.css('display', 'none');
                    } else {
                        $element.css('display', prevDisp);
                    }
                }
                
                // Initial evaluation
                updateVisibility();
                
                // Re-evaluate when impersonation state changes
                var deregister = $rootScope.$on('impersonation:changed', function() {
                    updateVisibility();
                });
                
                // Clean up listener when scope is destroyed
                scope.$on('$destroy', function() {
                    deregister();
                });
            }
        }
    }])

    .directive('accessEnable', ['Auth', 'USER_ROLES', '$rootScope', function (Auth, USER_ROLES, $rootScope) {
        return {
            scope: true,
            restrict: 'A',
            link: function (scope, $element, attrs) {
                var prevDisabled = $element.prop('disabled') || false;
                var requiredRoles = attrs.accessEnable.split(/[,\s]+/);
                
                function updateEnabled() {
                    if (!Auth.authorize(requiredRoles)) {
                        $element.prop('disabled', true);
                    } else {
                        $element.prop('disabled', prevDisabled);
                    }
                }
                
                // Initial evaluation
                updateEnabled();
                
                // Re-evaluate when impersonation state changes
                var deregister = $rootScope.$on('impersonation:changed', function() {
                    updateEnabled();
                });
                
                // Clean up listener when scope is destroyed
                scope.$on('$destroy', function() {
                    deregister();
                });
            }
        }
    }])

    .directive('expandNote', [function () {
        return {
            scope: true,
            restrict: 'A',
            link: function (scope, $element, attrs) {
                $element.children('.note-expand').on('click', function () {
                    $element.toggleClass('expand');
                });

            }
        }

    }])

    .directive('stateSelect', ['US_STATES', function (US_STATES) {
        return {
            restrict: 'E',
            templateUrl: 'partials/state_select.html',
            scope: {
                'disabled': '<',
                'address': '='
            },
            controller: ['$scope', function($scope) {
                $scope.states = US_STATES;
            }]
        };
    }])

    .directive('attachmentThumb', ['$timeout', '$http', '$window', function ($timeout, $http, $window) {
        // Retry delays in milliseconds: 1s, 3s, 10s
        var RETRY_DELAYS = [1000, 3000, 10000];

        function loadThumbnailWithRetry(element, thumbUrl, retryCount) {
            retryCount = retryCount || 0;

            var img = angular.element('<img/>');
            img.attr('src', thumbUrl);

            img.on('load', function () {
                angular.element(this).remove();
                element.attr('style', "background: url('" + thumbUrl + "') no-repeat top/contain");
            });

            img.on('error', function () {
                angular.element(this).remove();
                // Retry if we haven't exceeded max retries
                if (retryCount < RETRY_DELAYS.length) {
                    $timeout(function () {
                        loadThumbnailWithRetry(element, thumbUrl, retryCount + 1);
                    }, RETRY_DELAYS[retryCount]);
                }
                // After all retries, keep showing the loader (processing placeholder)
            });
        }

        return {
            link: function (scope, element, attributes) {
                // Guest drafts (DCL-440) can't send the X-Draft-Edit-Token header
                // from a plain <img>, so when thumb-headers evaluates to a non-empty
                // object we fetch the thumbnail as a blob with the token and paint it
                // via an object URL. The object URL is revoked when replaced and on
                // $destroy. Same retry cadence as the plain path (the thumbnail may
                // 404 while it is still being generated).
                var objectUrl = null;
                function revoke() {
                    if (objectUrl) {
                        $window.URL.revokeObjectURL(objectUrl);
                        objectUrl = null;
                    }
                }
                function loadThumbnailWithHeaders(thumbUrl, headers, retryCount) {
                    retryCount = retryCount || 0;
                    $http({method: 'GET', url: thumbUrl, responseType: 'blob', headers: headers, withCredentials: true})
                        .then(function (response) {
                            revoke();
                            objectUrl = $window.URL.createObjectURL(response.data);
                            element.attr('style', "background: url('" + objectUrl + "') no-repeat top/contain");
                        }, function () {
                            if (retryCount < RETRY_DELAYS.length) {
                                $timeout(function () {
                                    loadThumbnailWithHeaders(thumbUrl, headers, retryCount + 1);
                                }, RETRY_DELAYS[retryCount]);
                            }
                            // After all retries, keep showing the loader (processing placeholder)
                        });
                }

                var type = attributes.attachmentThumb.slice(attributes.attachmentThumb.lastIndexOf('.') + 1);
                var cssClass;
                switch (type.toLowerCase()) {
                    case 'doc':
                    case 'docx':
                        cssClass = 'attach-word';
                        break;
                    case 'xls':
                    case 'xlsx':
                        cssClass = 'attach-excel';
                        break;
                    case 'pdf':
                        cssClass = 'attach-pdf';
                        break;
                    case 'jpg':
                    case 'jpeg':
                    case 'png':
                    case 'gif':
                        element.attr('style', "background: url('img/loader.gif') no-repeat top");
                        var thumbUrl = attributes.attachmentThumb + "&is_thumb=true";
                        var thumbHeaders = attributes.thumbHeaders ? scope.$eval(attributes.thumbHeaders) : null;
                        if (thumbHeaders && !angular.equals(thumbHeaders, {})) {
                            loadThumbnailWithHeaders(thumbUrl, thumbHeaders, 0);
                            scope.$on('$destroy', revoke);
                        } else {
                            loadThumbnailWithRetry(element, thumbUrl, 0);
                        }
                        cssClass = '';
                        break;
                    case 'stl':
                        cssClass = 'attach-stl';
                        break;
                    default:
                        cssClass = 'attach-file';

                }
                element.addClass(cssClass);
            }
        }
    }])

    .directive('ngThumb', ['$window', 'ImageUtils', function ($window, ImageUtils) {
        var helper = {
            support: !!($window.FileReader && $window.CanvasRenderingContext2D),
            isFile: function (item) {
                return angular.isObject(item) && item instanceof $window.File;
            },
            isImage: function (file) {
                var type = '|' + file.type.slice(file.type.lastIndexOf('/') + 1) + '|';
                return '|jpg|png|jpeg|bmp|gif|'.indexOf(type) !== -1;
            }
        };

        return {
            restrict: 'A',
            template: '<canvas/>',
            link: function (scope, element, attributes) {
                if (!helper.support) return;

                var params = scope.$eval(attributes.ngThumb);

                if (!helper.isFile(params.file)) return;
                /*if (!helper.isImage(params.file)) return;*/

                if (!helper.isImage(params.file)) {
                    var type = params.file.name.slice(params.file.name.lastIndexOf('.') + 1);
                    var cssClass = '';
                    switch (type.toLowerCase()) {
                        case 'docx':
                        case 'doc':
                            cssClass = 'attach-word';
                            break;
                        case 'pdf':
                            cssClass = 'attach-pdf';
                            break;
                        case 'xlsx':
                        case 'xls':
                            cssClass = 'attach-excel';
                            break;
                        case 'jpg':
                        case 'jpeg':
                        case 'png':
                        case 'gif':
                            cssClass = '';
                            break;
                        case 'stl':
                            cssClass = 'attach-stl';
                            break;
                        default:
                            cssClass = 'attach-file';
                    }
                    element.addClass(cssClass)
                }
                var canvas = element.find('canvas');
                var reader = new FileReader();

                reader.onload = onLoadFile;
                reader.readAsDataURL(params.file);

                function onLoadFile(event) {
                    var img = new Image();
                    img.onload = onLoadImage;
                    img.src = event.target.result;
                }

                function onLoadImage() {
                    var canvasImgDimensions = ImageUtils.resizeImageKeepingAspectRatio({ width: this.width, height: this.height }, params.longEdgeSize);
                    canvas.attr({ width: canvasImgDimensions.width, height: canvasImgDimensions.height });
                    canvas[0].getContext('2d').drawImage(this, 0, 0, canvasImgDimensions.width, canvasImgDimensions.height);
                }
            }
        };
    }])

    .directive('dateRangePicker', ['$parse', function ($parse) {
        return {
            restrict: 'A',
            link: function (scope, $element, attrs) {
                const beginningOfTime = moment("20140101", "YYYYMMDD").startOf('day');
                const endOfToday = moment().endOf('day');

                function updateLabel(start, end) {
                    if (start.isSameOrBefore(beginningOfTime) && end.isSame(endOfToday)) {
                        $element.find('span').html('All');
                    } else {
                        $element.find('span').html(start.format('MMMM D, YYYY') + ' - ' + end.format('MMMM D, YYYY'));
                    }
                }

                const dateRangeCallback = $parse(attrs.dateRangePicker);
                $element.daterangepicker(
                    {
                        minDate: beginningOfTime,
                        maxDate: endOfToday,
                        startDate: scope.start_date,
                        endDate: scope.end_date,
                        ranges: {
                            'Last 7 Days': [moment().subtract(6, 'day'), moment()],
                            'Last 30 Days': [moment().subtract(29, 'day'), moment()],
                            'All': [beginningOfTime, endOfToday]
                        },
                        linkedCalendars: false,
                        showDropdowns: true,
                        autoApply: true
                    },
                    function (start, end) {
                        updateLabel(start, end);
                        dateRangeCallback(scope, { start: start, end: end });
                    }
                );

                if (scope.start_date && scope.end_date) {
                    if (isMoment(scope.start_date) && scope.start_date.isBefore(beginningOfTime)) {
                        scope.start_date = beginningOfTime;
                    }
                } else {
                    scope.start_date = beginningOfTime;
                    scope.end_date = endOfToday;
                }
                updateLabel(moment(scope.start_date), moment(scope.end_date));
            }
        }
    }])

    .directive('editForm', [function () {
        return {
            restrict: 'A',
            scope: {
                source: '=?editForm',
                showLabels: '=?'
            },
            controller: ['$scope', '$element', function ($scope, $element) {
                if (typeof $scope.showLabels === 'undefined') {
                    $scope.showLabels = false;
                }
                //we now can't store pre-found input and select elements as a variables because of ng-repeat directive for multiple addresses (it doesn't find elements inside ng-repeat)
                this.enableControls = function () {
                    $element.find('input').removeClass('data1').removeAttr('disabled');
                    $element.find('select').removeClass('data1').removeAttr('disabled');
                    if (!$scope.showLabels) {
                        $element.find('label').removeClass('hidden');
                    }
                };
                this.disableControls = function () {
                    $element.find('input').addClass('data1').attr('disabled', 'disabled');
                    $element.find('select').addClass('data1').attr('disabled', 'disabled');
                    if (!$scope.showLabels) {
                        $element.find('label').addClass('hidden');
                    }
                };
            }]
        }
    }])

    .directive('toggleEdit', ['PracticeEditMode', function (PracticeEditMode) {
        return {
            scope: {},
            restrict: 'A',
            require: ['^editForm', '^form'],
            link: function (scope, $element, attrs, formCtrls) {

                var editFormCtrl = formCtrls[0];
                var formCtrl = formCtrls[1];
                var editButton = $element;
                var addAddressButton = $element.next();
                var saveButton = $element.next().next();

                PracticeEditMode.init(editFormCtrl, formCtrl, editButton, addAddressButton, saveButton);
                PracticeEditMode.off();

                // edit
                editButton.on('click', function (e) {
                    PracticeEditMode.init(editFormCtrl, formCtrl, editButton, addAddressButton, saveButton);
                    PracticeEditMode.on();
                });

                // save
                saveButton.on('click', function (e) {
                    PracticeEditMode.init(editFormCtrl, formCtrl, editButton, addAddressButton, saveButton);
                    PracticeEditMode.off();
                });

                if (attrs.toggleEdit) {
                    editButton.triggerHandler('click');
                }
            }
        }

    }])

    .directive('ngFocusMe', ['$parse', '$timeout', function ($parse, $timeout) {
        return {
            restrict: 'AC',
            link: function (scope, element, attrs) {
                $timeout(function () {
                    element[0].focus();
                }, 100);
            }
        }
    }])

    .directive('focusPassword', [function () {
        return {
            restrict: 'A',
            link: function (scope, element) {
                scope.$on("focusPassword", function () {
                    element[0].focus();

                });
            }
        }
    }])

    .directive('ngCtrlEnter', ['$parse', '$timeout', function ($parse, $timeout) {
        return {
            restrict: 'AC',
            link: function (scope, element, attrs) {

                element.bind("keydown keypress", function (event) {
                    if (event.which === 13 && event.ctrlKey == true) {
                        scope.$apply(function () {
                            scope.$eval(attrs.ngCtrlEnter, { 'event': event });
                        });

                        event.preventDefault();
                    }
                });
            }
        }
    }])

    .directive('stopEvent', function () {
        return {
            restrict: 'A',
            link: function (scope, element, attr) {
                element.bind(attr.stopEvent, function (e) {
                    e.preventDefault();
                    e.stopPropagation();

                });
            }
        };
    })

    .directive('attachments', [function () {
        return {
            restrict: 'E',
            transclude: true,
            templateUrl: 'partials/attachments.html',
            controller: 'AttachmentsController'
        }

    }])

    // Bridges a hidden file/directory <input> to the CBCT strip handler: native
    // file inputs don't fire ng-change, so bind the DOM change event and hand
    // the FileList to scope.cbctOnFilesSelected inside a digest. (DCL-211)
    .directive('cbctFileInput', [function () {
        return {
            restrict: 'A',
            link: function (scope, $element) {
                $element.on('change', function (event) {
                    var files = event.target.files;
                    scope.$apply(function () {
                        if (typeof scope.cbctOnFilesSelected === 'function') {
                            scope.cbctOnFilesSelected(files);
                        }
                    });
                });
            }
        };
    }])

    .directive('teethChart', [function () {
        return {
            restrict: 'E',
            transclude: true,
            templateUrl: 'partials/teeth_chart.html',
            controller: 'TeethController'
        }

    }])

    .directive('notes', [function () {
        return {
            restrict: 'E',
            scope: {
                referral: '=',
                immediateUpdate: '=',
                showOfferToInviteGuest: '=',
                readOnly: '=',
                // a draft autosave request is in flight (DCL-636)
                busy: '<'
            },
            templateUrl: 'partials/notes.html',
            controller: 'NotesController'
        };
    }])

    // DCL-702: $compile runs any `{{ }}` or directive in its input, and AngularJS
    // 1.8 has no expression sandbox, so only our own strings may be compiled: an
    // i18n dictionary value, or a constant the caller wrapped in $sce.trustAsHtml.
    // Everything else (the /error/:error_key URL parameter, upload file names,
    // server messages) is shown as text. $sanitize would not do: it keeps <a> and
    // <img>, so a crafted /error link could still put a working link in the alert.
    .directive('dynamicHtml', ['$compile', '$sce', 'localize', function ($compile, $sce, localize) {
        return {
            restrict: 'A',
            replace: true,
            link: function (scope, element, attrs) {
                scope.$watch(attrs.dynamicHtml, function (value) {
                    var unwrapped = $sce.valueOf(value);
                    if (unwrapped !== value || localize.isLocalizedString(value)) {
                        element.html(unwrapped);
                        $compile(element.contents())(scope);
                    } else {
                        element.text(value === undefined || value === null ? '' : String(value));
                    }
                });
            }
        };
    }])

    .directive('stateLicenseButton', ['StateLicenseService', '$sce', function(StateLicenseService, $sce) {
        return {
            restrict: 'E',
            scope: {
                state: '<',
                provider: '<'
            },
            template: '<span dynamic-html="licenseButtonHtml"></span>',
            link: function(scope) {
                function update() {
                    // Constants from statesData.js; they need compiling for ng-href and ng-value.
                    scope.licenseButtonHtml = $sce.trustAsHtml(StateLicenseService.getLicenseSnippet(scope.state));
                }

                scope.$watchGroup(['state'], update);
                update();
            }
        };
    }])

    .directive('rolesSelector', ['$compile', function ($compile) {
        return {
            restrict: 'A',
            replace: true,
            scope: {
                inputMask: '=',
                defaultRoles: '=',
                showRoles: '=',
                onChange: '='
            },
            templateUrl: 'partials/roles_selector.html',
            controller: 'RolesSelectorController'
        };
    }])

    .directive('userAddresses', [function () {
        return {
            restrict: 'E',
            replace: true,
            scope: {
                user: '=',
                practiceAddresses: '='
            },
            templateUrl: 'partials/user_addresses.html',
            controller: 'UserAddressesController'
        };
    }])

    .directive('phoneFormatter', ['$compile', function ($compile) {
        return {
            terminal: true,
            priority: 1000,
            restrict: 'A',
            link: function (scope, element, attrs) {
                attrs.$set('ui-mask', '(999) 999-9999');
                attrs.$set('placeholder', '(xxx) xxx-xxxx');
                element.removeAttr('phone-formatter');
                $compile(element)(scope);
            }
        };
    }]);
